import React from 'react';
import './LicenseLitespeed.css';

const LicenseLitespeed = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const features = [
    'فعال‌سازی آنی و بدون معطلی',
    'لایسنس اورجینال و رسمی',
    'نصب و راه‌اندازی رایگان توسط تیم افرسل',
    'پشتیبانی ۲۴ ساعته و ۷ روز هفته',
    'قیمت رقابتی و مناسب',
    'به‌روزرسانی خودکار',
  ];

  return (
    <>
      <div className="seo-header">
        <h1>لایسنس LiteSpeed | خرید لایسنس اورجینال با بهترین قیمت | افرسل</h1>
        <p>خرید لایسنس LiteSpeed وب‌سرور فوق‌سریع با کش پیشرفته و بهینه‌سازی عملکرد. جایگزین قدرتمند Apache با سرعت بارگذاری بالا و مصرف منابع بهینه. فعال‌سازی آنی، نصب رایگان و پشتیبانی ۲۴ ساعته. بهترین قیمت لایسنس لایسنس LiteSpeed را از افرسل تهیه کنید.</p>
        <meta name="description" content="خرید لایسنس LiteSpeed وب‌سرور فوق‌سریع با کش پیشرفته و بهینه‌سازی عملکرد. جایگزین قدرتمند Apache با سرعت بارگذاری بالا و مصرف منابع بهینه. فعال‌سازی آنی، نصب رایگان و پشتیبانی ۲۴ ساعته. بهترین قیمت لایسنس لایسنس LiteSpeed را از افرسل تهیه کنید." />
      </div>

      <section className="license-detail-hero">
        <div className="license-detail-hero-bg"></div>
        <div className="wrap">
          <div className="license-detail-hero-content">
            <div className="license-detail-badge" style={{ borderColor: '#F59E0B', color: '#F59E0B' }}>
              <span className="pulse-dot" style={{ background: '#F59E0B' }}></span>
              🚀 لایسنس LiteSpeed
            </div>
            <h1 className="license-detail-hero-title">
              لایسنس LiteSpeed <em>اورجینال</em>
            </h1>
            <p className="license-detail-hero-desc">
              خرید لایسنس LiteSpeed وب‌سرور فوق‌سریع با کش پیشرفته و بهینه‌سازی عملکرد. جایگزین قدرتمند Apache با سرعت بارگذاری بالا و مصرف منابع بهینه.
              <br /><br />
              لایسنس لایسنس LiteSpeed اورجینال با فعال‌سازی آنی، نصب رایگان توسط تیم حرفه‌ای افرسل و پشتیبانی ۲۴ ساعته.
              بهترین قیمت لایسنس لایسنس LiteSpeed را در افرسل تجربه کنید.
            </p>
            <div className="license-detail-hero-stats">
              <div className="stat-item">
                <span className="stat-number">اورجینال</span>
                <span className="stat-label">۱۰۰٪ تضمینی</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">آنی</span>
                <span className="stat-label">فعال‌سازی</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="license-detail-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای لایسنس LiteSpeed</span>
            <h2 className="sec-h">چرا <em>لایسنس LiteSpeed</em> با افرسل؟</h2>
            <p className="sec-p">لایسنس اورجینال با بهترین خدمات و پشتیبانی حرفه‌ای.</p>
          </div>
          <div className="license-detail-features-grid">
            {features.map((feat, i) => (
              <div key={i} className="license-detail-feature-card">
                <span className="license-detail-feature-icon">✓</span>
                <div>
                  <h3 className="license-detail-feature-title">{feat}</h3>
                  <p className="license-detail-feature-desc">
                    {feat === 'فعال‌سازی آنی و بدون معطلی' && 'پس از خرید، لایسنس شما بلافاصله فعال می‌شود و می‌توانید از آن استفاده کنید. بدون هیچ گونه تاخیر یا معطلی.'}
                    {feat === 'لایسنس اورجینال و رسمی' && 'همه لایسنس‌های افرسل اورجینال و مستقیماً از شرکت‌های تولیدکننده تهیه می‌شوند. با خیال راحت خرید کنید.'}
                    {feat === 'نصب و راه‌اندازی رایگان توسط تیم افرسل' && 'تیم حرفه‌ای افرسل لایسنس شما را به صورت رایگان نصب و راه‌اندازی می‌کند. بدون هزینه اضافی.'}
                    {feat === 'پشتیبانی ۲۴ ساعته و ۷ روز هفته' && 'تیم پشتیبانی افرسل به صورت شبانه‌روزی در دسترس شماست تا هرگونه مشکل یا سوالی را پاسخ دهد.'}
                    {feat === 'قیمت رقابتی و مناسب' && 'بهترین قیمت لایسنس‌های اورجینال را در افرسل پیدا کنید. قیمت‌های شفاف و رقابتی.'}
                    {feat === 'به‌روزرسانی خودکار' && 'لایسنس شما به صورت خودکار به‌روز می‌شود و همیشه از آخرین نسخه استفاده می‌کنید.'}
                    {!['فعال‌سازی آنی و بدون معطلی','لایسنس اورجینال و رسمی','نصب و راه‌اندازی رایگان توسط تیم افرسل','پشتیبانی ۲۴ ساعته و ۷ روز هفته','قیمت رقابتی و مناسب','به‌روزرسانی خودکار'].includes(feat) && ''}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="license-detail-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              لایسنس LiteSpeed <em>اورجینال</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید لایسنس لایسنس LiteSpeed از افرسل، از اورجینال بودن، فعال‌سازی آنی و پشتیبانی ۲۴ ساعته اطمینان داشته باشید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید لایسنس</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LicenseLitespeed;
